import { ClipboardList, Radar, Tag, TrendingUp } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const STEPS = [
  { icon: ClipboardList, title: "Müşteri Talep Oluşturur", desc: "Araç sahibi bulunduğu konumdan ihtiyacı olan hizmeti seçerek talep oluşturur." },
  { icon: Radar, title: "Talebi Görürsün", desc: "Hizmet bölgenle eşleşen yeni talepleri görüntülersin." },
  { icon: Tag, title: "Teklifini Verirsin", desc: "Uygun gördüğün talepler için kendi teklifini oluşturursun." },
  { icon: TrendingUp, title: "Yeni Müşteriler Kazanırsın", desc: "Müşteri teklifini seçtiğinde hizmeti gerçekleştirir ve müşteri portföyünü büyütürsün." },
];

export const HowItWorks = () => {
  return (
    <section id="nasil-calisir" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <SectionLabel>Süreç</SectionLabel>
          <h2 className="mt-5 max-w-2xl font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#172033]">
            YıkaGel Nasıl Çalışır?
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div
                  data-testid={`step-card-${i + 1}`}
                  className="group relative h-full rounded-3xl border border-gray-100 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(11,59,117,0.35)]"
                >
                  <span className="pointer-events-none absolute right-5 top-3 font-heading text-7xl font-black text-[#F1F5F9] transition-colors group-hover:text-[#E6F0FF]">
                    {i + 1}
                  </span>
                  <span className="relative inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[#1677FF] to-[#22C7D6] text-white shadow-[0_10px_24px_-8px_rgba(22,119,255,0.6)]">
                    <Icon size={24} />
                  </span>
                  <h3 className="relative mt-6 font-heading text-xl font-bold text-[#172033]">{s.title}</h3>
                  <p className="relative mt-3 text-[15px] leading-relaxed text-[#667085]">{s.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
